import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function constructBBAN(bban: string): string {
  if (!bban) return "";
  // Remove any existing dashes
  const clean = bban.replace(/-/g, "");
  // Format as 1234-12-123456
  return `${clean.slice(0, 4)}-${clean.slice(4, 6)}-${clean.slice(6)}`;
}

/**
 * Build full BBAN from bank (4), hb (2), reikn (6) form values.
 * Pads bank to 4 digits and reikn to 6 digits.
 */
export function getBBAN(formValues: {
  bank: string;
  hb: string;
  reikn: string;
}): string {
  const { bank, hb, reikn } = formValues;
  return `${bank.padStart(4, "0")}${hb}${reikn.padStart(6, "0")}`;
}

export function renderBankName(bankId: string) {
  switch (bankId) {
    case "lbi":
      return "Landsbankinn";
    case "arion":
      return "Arion";
    case "isb":
      return "Íslandsbanki";
    case "kvika":
      return "Kvika";
  }
}
